import { Injectable, inject } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { Router } from '@angular/router';
import { AuthService } from './auth.service';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class InactivityLogoutService {
  private static readonly InactivityTimeoutMs = 20 * 60 * 1000;

  private readonly msalService = inject(MsalService);
  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);
  private timeoutHandle: ReturnType<typeof setTimeout> | null = null;
  private started = false;
  private readonly trackedEvents = ['pointerdown', 'keydown', 'mousemove', 'scroll', 'touchstart'];

  start(): void {
    if (this.started) {
      return;
    }

    this.started = true;

    for (const eventName of this.trackedEvents) {
      window.addEventListener(eventName, this.onUserActivity, { passive: true });
    }

    this.resetTimer();
  }

  private readonly onUserActivity = (): void => {
    this.resetTimer();
  };

  private resetTimer(): void {
    if (this.timeoutHandle !== null) {
      clearTimeout(this.timeoutHandle);
    }

    this.timeoutHandle = setTimeout(() => {
      void this.handleInactivityTimeoutAsync();
    }, InactivityLogoutService.InactivityTimeoutMs);
  }

  private async handleInactivityTimeoutAsync(): Promise<void> {
    const account = this.authService.getActiveAccount();
    if (!account) {
      this.resetTimer();
      return;
    }

    if (environment.devSimulateAuth) {
      this.authService.simLogout();
      await this.router.navigate(['/public']);
      return;
    }

    await this.msalService.logoutRedirect({ postLogoutRedirectUri: '/public' });
  }
}
